import { PiWarningCircleBold } from "react-icons/pi";
import Sidebar from "./Sidebar";
import { MdLocalPolice } from "react-icons/md";
import { FaAmbulance, FaFire, FaLongArrowAltLeft } from "react-icons/fa";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { IoSettingsOutline } from "react-icons/io5";

export default function Emergency() {

    const [country, setCountry] = useState("JP");
    const [countryName, setCountryName] = useState("Japan");
    const [list, setList] = useState([]);

    const [theme, setTheme] = useState(localStorage.getItem("theme") || "dark");

    useEffect(() => {
        const savedTheme = localStorage.getItem("theme") || "dark";
        setTheme(savedTheme);
    }, []);

    const pageBg = theme === "dark" ? "dashboard-bg" : "bg-light";
    const cardBg = theme === "dark" ? "backgroundd-bg text-light" : "bg-white text-dark";
    const btnSecondary = theme === "dark" ? "btn btn-dark text-light" : "btn btn-gradientss text-light";
    const textColor = theme === "dark" ? "text-light" : "text-dark";

    const emergencyData = {
        IN: [
            { icon: <MdLocalPolice size={24} />, name: "Police", number: "112" },
            { icon: <FaAmbulance size={24} className="text-danger" />, name: "Ambulance", number: "108" },
            { icon: <FaFire size={24} className="text-warning" />, name: "Fire", number: "101" },
        ],
        US: [
            { icon: <MdLocalPolice size={24} />, name: "Emergency", number: "911" },
            { icon: <FaAmbulance size={24} className="text-danger" />, name: "Medical", number: "911" },
            { icon: <FaFire size={24} className="text-warning" />, name: "Fire", number: "911" },
        ],
        CA: [
            { icon: <MdLocalPolice size={24} />, name: "Emergency", number: "911" },
            { icon: <FaAmbulance size={24} className="text-danger" />, name: "Ambulance", number: "911" },
            { icon: <FaFire size={24} className="text-warning" />, name: "Fire", number: "911" },
        ],
        GB: [
            { icon: <MdLocalPolice size={24} />, name: "Emergency", number: "999" },
            { icon: <FaAmbulance size={24} className="text-danger" />, name: "Ambulance", number: "999" },
            { icon: <FaFire size={24} className="text-warning" />, name: "Fire", number: "999" },
        ],
        AU: [
            { icon: <MdLocalPolice size={24} />, name: "Emergency", number: "000" },
            { icon: <FaAmbulance size={24} className="text-danger" />, name: "Ambulance", number: "000" },
            { icon: <FaFire size={24} className="text-warning" />, name: "Fire", number: "000" },
        ],
        DE: [
            { icon: <MdLocalPolice size={24} />, name: "Police", number: "110" },
            { icon: <FaAmbulance size={24} className="text-danger" />, name: "Medical", number: "112" },
            { icon: <FaFire size={24} className="text-warning" />, name: "Fire", number: "112" },
        ],
        FR: [
            { icon: <MdLocalPolice size={24} />, name: "Police", number: "17" },
            { icon: <FaAmbulance size={24} className="text-danger" />, name: "Ambulance", number: "15" },
            { icon: <FaFire size={24} className="text-warning" />, name: "Fire", number: "18" },
        ],
        IT: [
            { icon: <MdLocalPolice size={24} />, name: "Police", number: "112" },
            { icon: <FaAmbulance size={24} className="text-danger" />, name: "Ambulance", number: "118" },
            { icon: <FaFire size={24} className="text-warning" />, name: "Fire", number: "115" },
        ],
        ES: [
            { icon: <MdLocalPolice size={24} />, name: "Emergency", number: "112" },
            { icon: <FaAmbulance size={24} className="text-danger" />, name: "Ambulance", number: "112" },
            { icon: <FaFire size={24} className="text-warning" />, name: "Fire", number: "112" },
        ],
        JP: [
            { icon: <MdLocalPolice size={24} />, name: "Police", number: "110" },
            { icon: <FaAmbulance size={24} className="text-danger" />, name: "Ambulance", number: "119" },
            { icon: <FaFire size={24} className="text-warning" />, name: "Fire", number: "119" },
        ],
        CN: [
            { icon: <MdLocalPolice size={24} />, name: "Police", number: "110" },
            { icon: <FaAmbulance size={24} className="text-danger" />, name: "Ambulance", number: "120" },
            { icon: <FaFire size={24} className="text-warning" />, name: "Fire", number: "119" },
        ],
        SG: [
            { icon: <MdLocalPolice size={24} />, name: "Police", number: "999" },
            { icon: <FaAmbulance size={24} className="text-danger" />, name: "Ambulance", number: "995" },
            { icon: <FaFire size={24} className="text-warning" />, name: "Fire", number: "995" },
        ],
        AE: [
            { icon: <MdLocalPolice size={24} />, name: "Police", number: "999" },
            { icon: <FaAmbulance size={24} className="text-danger" />, name: "Ambulance", number: "998" },
            { icon: <FaFire size={24} className="text-warning" />, name: "Fire", number: "997" },
        ],
        SA: [
            { icon: <MdLocalPolice size={24} />, name: "Police", number: "999" },
            { icon: <FaAmbulance size={24} className="text-danger" />, name: "Ambulance", number: "997" },
            { icon: <FaFire size={24} className="text-warning" />, name: "Fire", number: "998" },
        ],
        PK: [
            { icon: <MdLocalPolice size={24} />, name: "Police", number: "15" },
            { icon: <FaAmbulance size={24} className="text-danger" />, name: "Ambulance", number: "115" },
            { icon: <FaFire size={24} className="text-warning" />, name: "Fire", number: "16" },
        ],
        BD: [
            { icon: <MdLocalPolice size={24} />, name: "Police", number: "999" },
            { icon: <FaAmbulance size={24} className="text-danger" />, name: "Ambulance", number: "199" },
            { icon: <FaFire size={24} className="text-warning" />, name: "Fire", number: "999" },
        ],
        BR: [
            { icon: <MdLocalPolice size={24} />, name: "Police", number: "190" },
            { icon: <FaAmbulance size={24} className="text-danger" />, name: "Ambulance", number: "192" },
            { icon: <FaFire size={24} className="text-warning" />, name: "Fire", number: "193" },
        ],
        MX: [
            { icon: <MdLocalPolice size={24} />, name: "Emergency", number: "911" },
            { icon: <FaAmbulance size={24} className="text-danger" />, name: "Ambulance", number: "911" },
            { icon: <FaFire size={24} className="text-warning" />, name: "Fire", number: "911" },
        ],
        ZA: [
            { icon: <MdLocalPolice size={24} />, name: "Police", number: "10111" },
            { icon: <FaAmbulance size={24} className="text-danger" />, name: "Ambulance", number: "10177" },
            { icon: <FaFire size={24} className="text-warning" />, name: "Fire", number: "10177" },
        ],
        NG: [
            { icon: <MdLocalPolice size={24} />, name: "Police", number: "112" },
            { icon: <FaAmbulance size={24} className="text-danger" />, name: "Ambulance", number: "199" },
            { icon: <FaFire size={24} className="text-warning" />, name: "Fire", number: "112" },
        ],
        KR: [
            { icon: <MdLocalPolice size={24} />, name: "Police", number: "112" },
            { icon: <FaAmbulance size={24} className="text-danger" />, name: "Ambulance", number: "119" },
            { icon: <FaFire size={24} className="text-warning" />, name: "Fire", number: "119" },
        ],
        TH: [
            { icon: <MdLocalPolice size={24} />, name: "Police", number: "191" },
            { icon: <FaAmbulance size={24} className="text-danger" />, name: "Ambulance", number: "1669" },
            { icon: <FaFire size={24} className="text-warning" />, name: "Fire", number: "199" },
        ]

    };

    useEffect(() => {

        const detectedCountry = localStorage.getItem("userCountry") || "JP";
        const detectedCountryName = localStorage.getItem("userCountryName") || "Japan";

        setCountry(detectedCountry);
        setCountryName(detectedCountryName);

        if (emergencyData[detectedCountry]) {
            setList(emergencyData[detectedCountry]);
        } else {
            setList(emergencyData["US"]);
        }

    }, []);

    return (
        <>
            <title>Emergency Numbers Worldwide – Police, Ambulance, Fire | TravelToolkit</title>
            <meta name="description" content="Access emergency numbers for every country instantly. TravelToolkit provides police, ambulance, and fire contact details worldwide to keep you safe while traveling." />
            <meta name="keywords" content="emergency numbers by country, police number worldwide, ambulance number international, fire emergency contact, travel safety numbers, global emergency contacts" />

            <meta property="og:title" content="Emergency Numbers Worldwide – Police, Ambulance, Fire | TravelToolkit" />
            <meta property="og:site_name" content="traveltoolkit" />
            <meta property="og:url" content="https://traveltoolkit.online/Emergency" />
            <meta property="og:description" content="Access emergency numbers for every country instantly. TravelToolkit provides police, ambulance, and fire contact details worldwide to keep you safe while traveling." />
            <meta property="og:image" content="earth.gif"></meta>

            <meta name="twitter:card" content="app" />
            <meta name="twitter:site" content="@traveltoolkit" />
            <meta name="twitter:description" content="Access emergency numbers for every country instantly. TravelToolkit provides police, ambulance, and fire contact details worldwide to keep you safe while traveling." />
            <meta name="twitter:app:country" content="India" />

            <div className="container-fluid p-0">
                <div className="row g-0">
                    <Sidebar />
                    <div className={`col-md-9 col-lg-10 ${pageBg} min-vh-100 p-3 offset-lg-2 offset-md-2`}>
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <div className="d-flex align-items-center gap-2">
                                <Link to="/Dashboard">
                                    <button className={btnSecondary}>
                                        <FaLongArrowAltLeft />
                                    </button>
                                </Link>
                                <h1 className={`${textColor} mb-0 h4`}>
                                    Emergency Services - {countryName} ({country})
                                </h1>
                            </div>
                            <Link to="/Settings">
                                <button className="btn btn-gradientss text-light">
                                    <IoSettingsOutline />
                                </button>
                            </Link>
                        </div>
                        <div className="row g-4">
                            {list.map((row, index) => (
                                <div key={index} className="col-md-4 col-sm-6 col-12">
                                    <div className={`card ${cardBg} text-center border-0 shadow-sm p-4`}>
                                        <div className="mb-3 fs-4">
                                            {row.icon}
                                        </div>
                                        <small className={`${textColor}`}>{row.name}</small>
                                        <h3 className="fw-bold">{row.number}</h3>
                                        <a href={`tel:${row.number}`} className="text-primary text-decoration-none">
                                            Tap to call
                                        </a>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}